import * as React from 'react';
import style from './create-website-banner.scss';
import bannerStyle from './banner.scss';
import { composer } from '../../component-decorators/composer';
import { Button, Box, Heading } from 'wix-style-react';
import { useConfigContext } from "../../config-context";
export var DevCenterBanner = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    // tslint:disable-next-line:react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    return (React.createElement(Box, { direction: "vertical", align: "center", backgroundColor: "#162d3d", maxHeight: "312px", className: bannerStyle.banner },
        React.createElement(Heading, { appearance: 'H2', light: true, className: style.titleBanner },
            t('standalone.devCenterBanner.title1'),
            "\u00A0",
            t('standalone.devCenterBanner.title2')),
        React.createElement(Box, { marginTop: "12px", className: style.buttonWrapper },
            React.createElement(Button, { skin: "light", priority: "secondary", size: isMobile ? "small" : "large", as: "a", href: "https://dev.wix.com", target: "_blank", dataHook: "dev-center-banner-cta" }, t('standalone.devCenterBanner.button')))));
});
export var PublicDevCenterBanner = function (_a) {
    var t = _a.t;
    return (React.createElement(Box, { direction: "vertical", align: "center", backgroundColor: "#162d3d", maxHeight: "312px", className: bannerStyle.banner },
        React.createElement(Heading, { appearance: 'H2', light: true, className: style.titleBanner },
            t('standalone.devCenterBanner.title1'),
            "\u00A0",
            t('standalone.devCenterBanner.title2')),
        React.createElement(Box, { marginTop: "14px", className: style.buttonWrapper },
            React.createElement(Button, { skin: "light", priority: "secondary", size: "large", as: "a", href: "https://dev.wix.com", target: "_blank", dataHook: "dev-center-banner-cta" }, t('standalone.devCenterBanner.button')))));
};
//# sourceMappingURL=dev-center-banner.js.map